var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Composant_239_1",
    "data-name": "Composant 239 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_5716",
    "data-name": "Rectangle 5716",
    fill: "rgba(240,102,73,0.1)",
    stroke: "#ec6321",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 119,
    height: 119,
    rx: 9.5,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "noun_Lock_2221605",
    transform: "translate(28.003 33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_12134",
    "data-name": "Trac\\xE9 12134",
    d: "M45.181,28.148V18.075a13.075,13.075,0,1,0-26.149,0V28.148a11.909,11.909,0,0,0,7.879,20.841H37.3a11.909,11.909,0,0,0,7.879-20.841ZM33.956,36.813l.818,5.02a2.7,2.7,0,1,1-5.336,0l.818-5.02a4.04,4.04,0,1,1,3.7,0ZM26.911,25.166a11.931,11.931,0,0,0-2.992.379v-7.47a8.187,8.187,0,1,1,16.374,0v7.47a11.932,11.932,0,0,0-2.992-.379Z",
    fill: "#ec6321"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLock);
export default __webpack_public_path__ + "static/media/ic-lock.1cbdda6b0948e99816ec813b1992c515.svg";
export { ForwardRef as ReactComponent };